module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('header', {
    staticClass: "main-header"
  }, [_c('span', {
    staticClass: "logo-mini"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'dashboard'
      }
    }
  }, [_c('a', {
    attrs: {
      "href": "/"
    }
  })])], 1), _vm._v(" "), _c('nav', {
    staticClass: "navbar navbar-static-top",
    attrs: {
      "role": "navigation"
    }
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "navbar-custom-menu"
  }, [_c('ul', {
    staticClass: "nav navbar-nav",
    staticStyle: {
      "float": "right"
    }
  }, [_c('li', {
    staticClass: "dropdown notifications-menu"
  }, [_c('ul', {
    staticClass: "dropdown-menu",
    attrs: {
      "id": "dropdown-notifications-menu"
    }
  }, [_c('li', {
    staticClass: "header"
  }, [_vm._v("You have " + _vm._s(_vm.unreadNotificationsCount) + " notification(s)")]), _vm._v(" "), (_vm.notifications.length > 0) ? _c('li', [_c('ul', {
    staticClass: "menu"
  }, _vm._l((_vm.notifications), function(notification, index) {
    return _c('li', {
      key: index,
      class: {
        'message-unread': !notification.hasRead
      }
    }, [_c('a', {
      attrs: {
        "href": "javascript:;"
      },
      on: {
        "click": function($event) {
          return _vm.goToProfile(notification.actingUser)
        }
      }
    }, [_c('img', {
      staticClass: "contacts-list-img",
      attrs: {
        "src": notification.actingUser.profileImageUrl,
        "alt": "Contact Avatar"
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "message-list-info"
    }, [_c('span', {
      staticClass: "message-list-name"
    }, [_c('span', [_vm._v(_vm._s(notification.actingUser.firstName) + " " + _vm._s(notification.actingUser.lastName))]), _vm._v(" "), _c('small', {
      staticClass: "message-list-date pull-right"
    }, [_vm._v(_vm._s(_vm._f("moment")(notification.createdAt, "MMM D, h:mm a")))])]), _vm._v(" "), _c('div', [_c('span', {
      staticClass: "message-list-msg"
    }, [_vm._v(_vm._s(notification.message))]), _vm._v(" "), (notification.hasRead) ? _c('span', {
      staticClass: "message-list-dot"
    }, [_c('button', {
      directives: [{
        name: "tooltip",
        rawName: "v-tooltip",
        value: ('Mark as unread'),
        expression: "'Mark as unread'"
      }],
      staticClass: "btn btn-box-tool",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.markNotificationAsUnread(notification)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-dot-circle-o"
    })])]) : _c('span', {
      staticClass: "message-list-dot"
    }, [_c('button', {
      directives: [{
        name: "tooltip",
        rawName: "v-tooltip",
        value: ('Mark as read'),
        expression: "'Mark as read'"
      }],
      staticClass: "btn btn-box-tool",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.markNotificationAsRead(notification)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-circle"
    })])])])])])])
  }), 0)]) : _vm._e(), _vm._v(" "), (_vm.notifications.length > 0) ? _c('li', {
    staticClass: "footer"
  }, [_c('a', {
    staticClass: "message-menu-link",
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.markAllNotificationsAsRead($event)
      }
    }
  }, [_vm._v("Mark All as Read")])]) : _vm._e()])]), _vm._v(" "), _c('li', {
    staticClass: "dropdown user user-menu"
  }, [_c('a', {
    staticClass: "dropdown-toggle",
    attrs: {
      "href": "#",
      "data-toggle": "dropdown"
    }
  }, [_c('img', {
    staticClass: "user-image",
    attrs: {
      "src": _vm.pictureUrl,
      "alt": "User Image"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "hidden-xs"
  }, [_vm._v(_vm._s(_vm.user.firstName) + " " + _vm._s(_vm.user.lastName))])]), _vm._v(" "), _c('ul', {
    staticClass: "dropdown-menu"
  }, [_c('li', {
    staticClass: "user-header"
  }, [_c('img', {
    staticClass: "img-circle",
    attrs: {
      "src": _vm.pictureUrl,
      "alt": "User Image"
    }
  }), _vm._v(" "), _c('p', [_vm._v("\n                " + _vm._s(_vm.user.firstName) + " " + _vm._s(_vm.user.lastName) + " - " + _vm._s(_vm.user.roleName) + "\n                "), _c('small', [_vm._v("Member since " + _vm._s(_vm._f("moment")(_vm.user.createdAt, "MMMM, YYYY")))])])]), _vm._v(" "), _c('li', {
    staticClass: "user-footer"
  }, [_c('div', {
    staticClass: "pull-left"
  }, [_c('router-link', {
    attrs: {
      "to": "/profile"
    }
  }, [_c('a', {
    staticClass: "btn btn-default btn-flat",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Profile")])])], 1), _vm._v(" "), _c('div', {
    staticClass: "pull-right"
  }, [_c('a', {
    staticClass: "btn btn-default btn-flat",
    attrs: {
      "href": "#"
    },
    on: {
      "click": _vm.logout
    }
  }, [_vm._v("Log out")])])])])])])])]), _vm._v(" "), _c('notifications')], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticStyle: {
      "width": "16%"
    }
  }, [_c('a', {
    staticClass: "sidebar-toggle",
    attrs: {
      "href": "javascript:;",
      "data-toggle": "push-menu",
      "role": "button"
    }
  }, [_c('span', {
    staticClass: "sr-only"
  }, [_vm._v("Toggle navigation")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "logo-mini col-xs-8",
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('b', [_c('h2', {
    staticClass: " logo1",
    staticStyle: {
      "margin-bottom": "12px",
      "font-size": "22px",
      "color": "black",
      "font-weight": "900",
      "margin-top": "12px",
      "margin-left": "65px"
    }
  }, [_vm._v("HASHBULLS ALGOTRADE PLATFORM ")])]), _vm._v(" "), _c('h2', {
    staticClass: "logo3 ",
    staticStyle: {
      "margin-bottom": "1px",
      "font-size": "22px",
      "color": "black",
      "font-weight": "900",
      "margin-top": "13px"
    }
  }, [_vm._v("HASHBULLS ALGOTRADE PLATFORM  ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0ceabd0c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/main/MainHeader.vue
// module id = 1944
// module chunks = 1